import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAgents } from '@/hooks/agents/useAgents';
import { useAuth } from '@/hooks/auth/useAuth';
import { useInboxFlowRuns } from '@reflex/plugin-flows/web/useFlows';
import { useDecisionGates } from '@/hooks/useDecisionGates';
import { useOrgRoutes } from '@/lib/useOrgRoutes';
import { InboxView } from './InboxView';

export function InboxPage() {
  const { user, activeMembership } = useAuth();
  const userId = user?.id ?? null;
  const { data: agents = [] } = useAgents({ userId });
  const { data: inboxRuns } = useInboxFlowRuns();
  // The inbox feed already filters to error/completed and applies the caps,
  // so a flat list of summaries is everything `buildBuckets` needs to render.
  const flowRuns = useMemo(
    () => [...(inboxRuns?.errors ?? []), ...(inboxRuns?.recentCompleted ?? [])],
    [inboxRuns],
  );
  const { data: gates = [] } = useDecisionGates();

  // The routed inbox is a takeover surface: the app shell steps aside (see
  // `isInboxPath`) and Back / `esc` return to the agent sessions page.
  const navigate = useNavigate();
  const routes = useOrgRoutes();
  const goBack = useCallback(() => {
    void navigate(routes.runs);
  }, [navigate, routes]);
  const takeover = useMemo(
    () => ({ onBack: goBack, orgName: activeMembership?.organization.name ?? 'Organization' }),
    [goBack, activeMembership],
  );

  return <InboxView agents={agents} flowRuns={flowRuns} gates={gates} takeover={takeover} />;
}
